import axios from '_u/axios'

// 工单/任务/客户/内外部用户统计
export const totalStatistic = () => {
    return axios.post('api/lltt/stats/totalStatistic')
}

// 近30天使用统计
export const usingCountStatistic = () => {
    return axios.post('api/lltt/stats/usingCountStatistic')
}